export default __webpack_public_path__ + "static/media/arrow-right.d13616f2.svg";